import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../styles'
import { Grid } from '@material-ui/core'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import Dialog from '../../components/dialog/Dialog'
import { hideModal } from '../../components/dialog/reducer/actions'
import { modalTypes } from '../../components/dialog/enum/modalTypes'
import { useDispatch, useSelector } from 'react-redux'
import { getModalContent, isModalVisible } from '../../components/dialog/reducer/selector'
import { FormattedMessage } from 'react-intl'
import Button from '../../components/button/Button'
import parse from 'html-react-parser'
import { acceptCGU } from './api/acceptCGU'
import { RootState } from '../reducers'
import { useMediaQuery } from 'react-responsive'

const useStyles = makeStyles((theme) => ({
	...styles(theme),
	iconStyle: {
		'&:hover': {
			background: theme.palette.blue['5']
		},
		position: 'absolute',
		top: 15,
		right: 12,
		borderRadius: '100%',
		color: theme.palette.blue.main,
		cursor: 'pointer'
	},
	dialogContainerLargeScreen: {
		padding: 35
	},
	dialogContainerSmallScreen: {
		padding: 10
	},
	footerContainerStyle: {
		marginTop: 30
	},
	buttonSmallStyle: {
		flexDirection: 'column-reverse',
		alignContent: 'center'
	},
	link: {
		marginTop: 10
	},
	message: {
		marginTop: 30
	}
}))

const PopinCGU = () => {
	const classes = useStyles()
	const dispatch = useDispatch()
    const isLargeScreen = useMediaQuery(
        {
            query: '(min-width: 1025px)'
        }
    )
	const cguModalIsOpen = useSelector((state: RootState) => isModalVisible(state, modalTypes.cguModal))
	const cguModelContent = useSelector((state: RootState) => getModalContent(state, modalTypes.cguModal))

	const dialogClass: ClassValue = classNames(
		isLargeScreen ? classes.dialogContainerLargeScreen : classes.dialogContainerSmallScreen
	)

	const dialogTitle: ClassValue = classNames(
		classes.colorAccessibility,
		classes.title2
	)

	const dialogText: ClassValue = classNames(
		classes.message,
		classes.text1
	)

	const closePopIn = () => {

	}

	const acceptCGUModal = () => {
		acceptCGU(`ec_${process.env.REACT_APP_TARGET}`)
			.then(() => {
				dispatch(hideModal(modalTypes.cguModal))
		})
	}

	return (
		<Dialog
			onCloseDialog={closePopIn}
			open={cguModalIsOpen}
			fullScreen={!isLargeScreen}
			maxWidth="md"
			withPadding={false}
		>
			<Grid item container className={dialogClass}>
				<Grid item xs={12} className={dialogTitle}>
					<FormattedMessage
						id="popinCGU.title"
						defaultMessage="Conditions Générales d'Utilisation"
						description="Dialog title"
					/>
				</Grid>
				<Grid item xs={12} className={dialogText}>
					{
						parse(cguModelContent.cgu_content ?? '')
					}
				</Grid>
				<Grid item xs={12} container justify="center" className={classes.footerContainerStyle}>
                    <Grid item xs={12} md={4} className={classes.link}>
                        <Button
                            background="backgroundAccessibility"
                            color="colorWhite"
                            textStyle="text8"
                            size="mediumButton"
                            onClick={acceptCGUModal}
                        >
                            <FormattedMessage
                                id="global.btn.accept"
                                defaultMessage="Accepter"
                                description="Accept"
                            />
                        </Button>
                    </Grid>
				</Grid>
			</Grid>
		</Dialog>
	)
}

export default PopinCGU
